import { IAuthState } from "@/interfaces/state";

export default {
  setToken: (state: IAuthState, payload: string): void => {
    state.token = payload;
    localStorage.setItem("token", payload);
  },
  setExpiresIn: (state: IAuthState, payload: number): void => {
    state.expiresIn = payload;
    localStorage.setItem("expiresIn", `${payload}`);
  },
  setType: (state: IAuthState, payload: string): void => {
    state.type = payload;
    localStorage.setItem("type", payload);
  },
};
